// Utilities for working with salon timezones.
// We store all timestamps in DB as UTC.
// booking_settings.timezone (IANA) defines the salon "wall clock" timezone.

export const DEFAULT_SALON_TIMEZONE = 'Europe/Prague';

// Minimal, EU-first mapping from ISO-2 country code -> IANA timezone.
// If a country spans multiple timezones, we choose a sensible default and allow
// the salon to adjust it later in Booking Settings.
const COUNTRY_TO_TIMEZONE: Record<string, string> = {
  // CZ / SK
  CZ: 'Europe/Prague',
  SK: 'Europe/Bratislava',

  // DACH
  DE: 'Europe/Berlin',
  AT: 'Europe/Vienna',
  CH: 'Europe/Zurich',

  // Central/Eastern EU
  PL: 'Europe/Warsaw',
  HU: 'Europe/Budapest',
  SI: 'Europe/Ljubljana',
  HR: 'Europe/Zagreb',
  RS: 'Europe/Belgrade',
  RO: 'Europe/Bucharest',
  BG: 'Europe/Sofia',

  // Baltics
  LT: 'Europe/Vilnius',
  LV: 'Europe/Riga',
  EE: 'Europe/Tallinn',

  // Nordics
  SE: 'Europe/Stockholm',
  NO: 'Europe/Oslo',
  DK: 'Europe/Copenhagen',
  FI: 'Europe/Helsinki',

  // Benelux
  NL: 'Europe/Amsterdam',
  BE: 'Europe/Brussels',
  LU: 'Europe/Luxembourg',

  // South/West
  ES: 'Europe/Madrid',
  PT: 'Europe/Lisbon',
  FR: 'Europe/Paris',
  IT: 'Europe/Rome',

  // Islands / special
  IE: 'Europe/Dublin',
  GB: 'Europe/London',
  IS: 'Atlantic/Reykjavik',

  // Greece / Turkey
  GR: 'Europe/Athens',
  TR: 'Europe/Istanbul',

  // Ukraine
  UA: 'Europe/Kyiv',

  // Russia (default to Moscow if ever used)
  RU: 'Europe/Moscow',
};

export function normalizeCountryCode(countryCode: string | null | undefined): string | null {
  const cc = (countryCode ?? '').trim().toUpperCase();
  if (!cc) return null;
  return cc;
}

export function getTimezoneForCountry(countryCode: string | null | undefined): string {
  const cc = normalizeCountryCode(countryCode);
  if (!cc) return DEFAULT_SALON_TIMEZONE;
  return COUNTRY_TO_TIMEZONE[cc] ?? DEFAULT_SALON_TIMEZONE;
}
